export default __webpack_public_path__ + "static/media/pink-pencil-18px.eea8182b.svg";